import React from "react";
import { Form } from "react-bootstrap";
import { FaMale, FaFemale, FaUserFriends } from "react-icons/fa";
import StudentDetailsSection from "./StudentDetailsSection";
import ParentProfileSection from "./ParentProfileSection";
import ExcelBulkUploadSection from "./ExcelBulkUploadSection";
import Button from "../../../components/Button/Button";

const StudentForm = ({
  isBulk,
  loader,
  submitHandler,
  changeHandler,
  onFocusHandler,
  errors,
  data,
  id,
  images,
  setImages,
  handleImageChange,
  programData,
  updateFlag,
  setUpdateFlag,
  bulkUploadFile,
  excelFileReader,
  downloadExcel,
  ...rest
}) => {
  const profileSections = [
    {
      title: "Father Details",
      icon: <FaMale />,
      color: "teal",
      imageKey: "father_profile_pic",
      fields: [
        { type: "select", label: "Father Prefix", name: "father_prefix", value: data.father_prefix, required: true, options: [{ id: "Mr.", name: "Mr." }, { id: "Dr.", name: "Dr." }], col: 6 },
        { type: "text", label: "Father First Name", name: "father_first_name", value: data.father_first_name, required: true, col: 6 },
        { type: "text", label: "Father Middle Name", name: "father_middle_name", value: data.father_middle_name, col: 6 },
        { type: "text", label: "Father Last Name", name: "father_last_name", value: data.father_last_name, col: 6 },
        { type: "email", label: "Father Email", name: "father_email", value: data.father_email, col: 6 },
        { type: "number", label: "Father Contact", name: "father_contact", value: data.father_contact, col: 6 },

      ],
    },
    {
      title: "Mother Details",
      icon: <FaFemale />,
      color: "violet",
      imageKey: "mother_profile_pic",
      fields: [
        { type: "select", label: "Mother Prefix", name: "mother_prefix", value: data.mother_prefix, required: true, options: [{ id: "Mrs.", name: "Mrs." }, { id: "Ms.", name: "Ms." }, { id: "Dr.", name: "Dr." }], col: 6 },
        { type: "text", label: "Mother First Name", name: "mother_first_name", value: data.mother_first_name, required: true, col: 6 },
        { type: "text", label: "Mother Middle Name", name: "mother_middle_name", value: data.mother_middle_name, col: 6 },
        { type: "text", label: "Mother Last Name", name: "mother_last_name", value: data.mother_last_name, col: 6 },
        { type: "email", label: "Mother Email", name: "mother_email", value: data.mother_email, col: 6 },
        { type: "number", label: "Mother Contact", name: "mother_contact", value: data.mother_contact, col: 6 },
      ],
    },
    {
      title: "Guardian Details",
      icon: <FaUserFriends />,
      color: "amber",
      imageKey: "guardian_profile_pic",
      fields: [
        { type: "select", label: "Guardian Prefix", name: "guardian_prefix", value: data.guardian_prefix, options: [{ id: "Mr.", name: "Mr." }, { id: "Mrs.", name: "Mrs." }, { id: "Ms.", name: "Ms." }, { id: "Dr.", name: "Dr." }], col: 6 },
        { type: "text", label: "Guardian First Name", name: "guardian_first_name", value: data.guardian_first_name, col: 6 },
        { type: "text", label: "Guardian Middle Name", name: "guardian_middle_name", value: data.guardian_middle_name, col: 6 },
        { type: "text", label: "Guardian Last Name", name: "guardian_last_name", value: data.guardian_last_name, col: 6 },
        { type: "email", label: "Guardian Email", name: "guardian_email", value: data.guardian_email, col: 6 },
        { type: "number", label: "Guardian Contact", name: "guardian_contact", value: data.guardian_contact, col: 6 },
      ],
    },
  ];

  return (
    <Form onSubmit={submitHandler}>
      {isBulk ? (
        <ExcelBulkUploadSection
          loader={loader}
          downloadExcel={downloadExcel}
          excelFileReader={excelFileReader}
          bulkUploadFile={bulkUploadFile}
          updateFlag={updateFlag}
          setUpdateFlag={setUpdateFlag}
        />
      ) : (
        <React.Fragment>
          <StudentDetailsSection
            data={data}
            errors={errors}
            images={images}
            setImages={setImages}
            changeHandler={changeHandler}
            onFocusHandler={onFocusHandler}
            handleImageChange={handleImageChange}
            programData={programData}
            {...rest}
          />

          {profileSections.map((section, idx) => (
            <ParentProfileSection
              key={idx}
              title={section.title}
              icon={section.icon}
              color={section.color}
              imageKey={section.imageKey}
              images={images}
              setImages={setImages}
              fields={section.fields}
              data={data}
              handleImageChange={handleImageChange}
              changeHandler={changeHandler}
              onFocusHandler={onFocusHandler}
              errors={errors}
              {...rest}
            />
          ))}

          <div className="col-md-12 d-flex justify-content-end">
            <div className="mt-4">
              <Button
                variant="primary"
                size="medium"
                disabled={loader}
                type="submit"
              >
                Submit
              </Button>
            </div>
          </div>
        </React.Fragment>
      )}
    </Form>
  );
};

export default StudentForm;
